
import React from 'react'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import {HeadingOne} from "Common/Custom/HeadingOne";
import CurrencyListTable from './Components/CurrencyListTable'
import DefaultCurrencyForm from './Components/DefaultCurrencyForm';
import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

const CurrencyList = () => {
  const [refresh, setRefresh] = useState(false);
  const handleUpdate = () => setRefresh(!refresh);

  return (
    <PageBody
     card={true}
     headerchildren={
        <>
        <HeadingOne>Currency List</HeadingOne>
        <AddItemBtn url="currency-add" title="Create Currency" />
        </>
       }>

      {/* Warning Alert */}
      <div className="col-12">
        <div className="alert alert-warning border-0 shadow-sm mb-4 d-flex align-items-center" role="alert">
          <div className="me-3">
            <AlertTriangle size={20} className="text-warning" />
          </div>
          <div>
            <strong>Important Notice:</strong> If you change the default currency, you must update all other currency rates according to the new base currency to maintain data accuracy.
          </div>
        </div>
      </div>

      {/* Default Currency Selection */}
      <div className="col-12">
        <div className="card mb-4">
          <div className="card-body">
            <DefaultCurrencyForm onUpdate={handleUpdate} refresh={refresh} />
          </div>
        </div>
      </div>

      {/* Table section */}
      <div className="col-12">
        <CurrencyListTable refresh={refresh} />
      </div>
    </PageBody>
  );
};

export default CurrencyList;
